module.exports = __webpack_public_path__ + "static/media/Katie.O_Dell_copy.50c0c6ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Katie.O_Dell_copy.jpg
// module id = 1226
// module chunks = 0